import Collapse from '@mui/material/Collapse';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectTimeSetting } from 'store/reducers/selectors';

import ChangeTimeType from './ChangeTimeType.jsx';
import TableUseTimeWindowsCheck from './TableUseTimeWindowsCheck.jsx';
import TimeSettingsCheckboxes from './TimeSettingsCheckboxes';

/**
 * Renders the TimeSettingsForm component, which displays time-related settings for a given table.
 *
 * @param {Object} props - The component props.
 * @param {string} props.tableName - The name of the table for which to display time settings.
 * @param {string} [props.minHeight='300px'] - The minimum height of the form container.
 * @param {boolean} props.addTableSwitches - Whether to include the table switches UI.
 * @param {boolean} props.addChangeTimeType - Whether to include the change time type UI.
 * @returns {JSX.Element} The rendered TimeSettingsForm component.
 */
export default function TimeSettingsForm({ tableName, minHeight = '300px', addTableSwitches, addChangeTimeType }) {
  const timeUseTimeWindows = useSelector(selectTimeSetting('useTimeWindows', tableName));

  return (
    <div style={{ minHeight, display: 'flex', flexFlow: 'row' }}>
      {addTableSwitches && <TableUseTimeWindowsCheck tableName={tableName} />}
      {addChangeTimeType && <ChangeTimeType />}
      <Collapse in={timeUseTimeWindows} unmountOnExit>
        <TimeSettingsCheckboxes tableName={tableName} />
      </Collapse>
    </div>
  );
}

TimeSettingsForm.propTypes = {
  tableName: PropTypes.string.isRequired,
  minHeight: PropTypes.string,
  addTableSwitches: PropTypes.bool,
  addChangeTimeType: PropTypes.bool
};
